// src/pages/OrderHeadReport.js
import { auth } from "../firebase";


import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Layout from "../components/Layout";
import {
  collection,
  getDocs,
  getDoc,
  doc,
  query,
  where,
} from "firebase/firestore";
import * as XLSX from "xlsx";
import { buildHsnSummary } from "../utils/hsnSummary";


import { onAuthStateChanged } from "firebase/auth";



const sendWhatsApp = (phone, message) => {
  if (!phone) {
    alert("Distributor phone number not available");
    return;
  }

  let cleanPhone = phone.replace(/\D/g, "");
  if (cleanPhone.length === 10) cleanPhone = "91" + cleanPhone;

  const url = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};



function OrderHeadReport() {

  const utilityBtn = {
    padding: "6px 12px",
    fontSize: "13px",
    fontWeight: 500,
    borderRadius: "6px",
    background: "#0d6efd",
    color: "#fff",
    border: "1px solid #0d6efd",
    cursor: "pointer",
  };

  const formatApprovedDate = (order) => {
    if (order?.approvedAt?.toDate) {
      return order.approvedAt.toDate().toLocaleDateString("en-IN");
    }
    if (order?.approvedDateOnly) {
      return new Date(order.approvedDateOnly).toLocaleDateString("en-IN");
    }
    return "-";
  };

  const buildWaMessage = (order) => `

Order Approved ✅




Order No: ${order.displayOrderId}
Distributor: ${order.partyName || ""}

Order Date: ${formatApprovedDate(order)}


Delivery Challan:
${order.challanPdfUrl || "Not available"}

– QuickBill
`.trim();


  const today = new Date().toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  const [rows, setRows] = useState([]);
  const [skuMaster, setSkuMaster] = useState({});

  const [partyMaster, setpartyMaster] = useState({});

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  // Auto-load company info
  useEffect(() => {
    const loadCompany = async () => {
      const ref = doc(db, "companyInfo", "default");
      const snap = await getDoc(ref);
      if (snap.exists()) setCompany(snap.data());
    };
    loadCompany();
    loadSkuMaster();

  }, []);

  // Auto-load today's report
  useEffect(() => {
    loadReport();
  }, [fromDate, toDate]);

  // ------------------------
  // Load report
  // ------------------------
  const loadReport = async () => {
    try {
      setLoading(true);
      const user = auth.currentUser;
      const userSnap = await getDoc(doc(db, "users", user.uid));
      const userData = userSnap.data();

      let q;
      if (userData?.role === "distributor") {
          q = query(collection(db, "orders"), 
                    where("distributorId", "==", userData.partyId || "---"),
                    where("status", "==", "APPROVED"));
      } else if (userData?.role === "ds") {
          q = query(collection(db, "orders"), 
                    where("dsId", "==", userData.dsId || "---"),
                    where("status", "==", "APPROVED"));
      } else {
          q = query(collection(db, "orders"), where("status", "==", "APPROVED"));
      }

      const snap = await getDocs(q);

      let list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

      const parse = (s) => (s ? new Date(s + "T00:00:00") : null);
      const from = parse(fromDate);
      const to = parse(toDate);

      list = list.filter((o) => {
        if (!o.approvedAt?.toDate) return false;
        const d = o.approvedAt.toDate();

        if (from && d < from) return false;
        if (to) {
          const end = new Date(to);
          end.setHours(23, 59, 59);
          if (d > end) return false;
        }
        return true;
      });

      list.sort((a, b) => new Date(b.approvedAt) - new Date(a.approvedAt));

      setRows(list);
    } catch (e) {
      console.error(e);
      alert("Error loading report");
    } finally {
      setLoading(false);
    }
  };

  // ------------------------
  // E-WAY BILL JSON BUILDER
  // ------------------------



  const loadSkuMaster = async () => {
    const snap = await getDocs(collection(db, "skuMaster"));
    let map = {};

    snap.forEach((d) => {
      const data = d.data();
      if (data.sku) {
        map[data.sku.trim().toUpperCase()] = data;
      }
    });

    setSkuMaster(map);
  };


















  const generateEwayJson = async (order) => {
    if (!company || !order) {
      alert("Missing company/order data");
      return;
    }

    let finalCompany = company;

    // 🚀 MULTI-LAYER branding fallback
    if (order.source === "DS_TO_OUTLET" && order.dsId) {
        const dsRef = query(collection(db, "dsMaster"), where("dsId", "==", order.dsId));
        const dsSnap = await getDocs(dsRef);
        if (!dsSnap.empty) {
            const distId = dsSnap.docs[0].data().distributorId;
            if (distId) {
                const distSnap = await getDoc(doc(db, "partyMaster", distId));
                if (distSnap.exists()) {
                    const d = distSnap.data();
                    finalCompany = {
                        ...finalCompany,
                        name: d.name || "",
                        address1: d.address || "",
                        address2: d.route || "",
                        phone: d.phone || "",
                        gstin: d.gstno || "",
                        place: d.place || "",
                        pincode: d.pincode || ""
                    };
                }
            }
        }
    }

    // ---------- Date FIX ----------
    const approvedDate =
      order.approvedAt?.toDate
        ? order.approvedAt.toDate()
        : new Date(order.approvedDateOnly);

    const formatDate = (d) => {
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    };

    // ---------- HSN SUMMARY ----------



    // ---------- BUILD HSN SUMMARY FROM SKU MASTER ----------

    const hsnMap = {};

    Object.entries(order.items || {}).forEach(([skuKey, qty]) => {
      const qtyNum = Number(qty || 0);
      if (qtyNum === 0) return;

      const sku = skuKey.trim().toUpperCase();
      const m = skuMaster[sku] || skuMaster[sku.toLowerCase()];

      if (!m) return;

      const hsn = m.hsn || "";

      if (!hsn) return;

      // 🚀 MULTI-TIER PRICING LOGIC
      let basicRate = Number(m.Basic_Eway || 0);
      if (order?.source === "DISTRIBUTOR_TO_DS") {
          basicRate = Number(m.dsBasicRate || m.Basic_Eway || 0);
      } else if (order?.source === "DISTRIBUTOR_APP") {
          basicRate = Number(m.distributorBasicRate || m.Basic_Eway || 0);
      }
      
      const gstRate = Number(m.gst || 0);
      const cessRate = Number(m.cess || 0);

      const taxable = qtyNum * basicRate;

      if (!hsnMap[hsn]) {
        hsnMap[hsn] = {
          hsn,
          qty: 0,
          taxable: 0,
          gstRate,
          cessRate,
          cessNonAdvol: 0,
          name: m.Name || "",
        };
      }

      hsnMap[hsn].qty += qtyNum;
      hsnMap[hsn].taxable += taxable;


      const addlCessPerUnit = Number(m.addlcess || 0);
      hsnMap[hsn].cessNonAdvol += qtyNum * addlCessPerUnit;

    });

    // ---------- BUILD ITEM LIST ----------

    const itemList = Object.values(hsnMap).map((row, i) => ({
      itemNo: i + 1,
      productName: "CIGARETTE",
      productDesc: "CIGARETTE",
      hsnCode: row.hsn,
      quantity: Number(row.qty.toFixed(2)),
      qtyUnit: "NOS",
      taxableAmount: Number(row.taxable.toFixed(2)),
      cgstRate: row.gstRate / 2,
      sgstRate: row.gstRate / 2,
      cessRate: row.cessRate,
      cessNonAdvol: Number(row.cessNonAdvol.toFixed(2)),

    }));









    // ---------- JSON BUILD ----------
    const json = {
      supplyType: "O",
      subSupplyType: "1",
      docType: "CHL",

      docNo: order.displayOrderId,
      docDate: formatDate(approvedDate),

      fromGstin: finalCompany.gstin || "",
      fromTrdName: finalCompany.name || "",
      fromAddr1: finalCompany.address1 || "",
      fromAddr2: finalCompany.address2 || "",
      fromPlace: finalCompany.place || "",
      fromPincode: String(finalCompany.pincode || ""),
      fromStateCode: String(finalCompany.statecode || ""),

      toGstin: order.gstno || "URP",
      toTrdName: order.partyName || "",
      toAddr1: order.address || "",
      toAddr2: "",
      toPlace: finalCompany.place || "",
      toPincode: String(finalCompany.pincode || ""),
      toStateCode: String(finalCompany.statecode || ""),

      totalValue: Number(order.ewayAmount || 0).toFixed(2),
      totalInvoiceValue: Number(order.ewayAmount || 0).toFixed(2),

      transMode: "1",
      transDistance: "50",
      vehicleNo: order.vehicleNo || "",
      vehicleType: "R",

      itemList,
    };

    // ---------- DOWNLOAD ----------
    const blob = new Blob([JSON.stringify(json, null, 2)], {
      type: "application/json",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `EWB-${order.displayOrderId}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };


















  // ------------------------
  // XLSX EXPORT
  // ------------------------
  const exportXLSX = () => {
    if (filteredRows.length === 0) {
      alert("No data to export!");
      return;
    }

    const excelData = filteredRows.map((r) => {
      const orderDisplayId =
        r.displayOrderId || r.finalOrderId || r.tempOrderId || r.id;

      return {
        "Order ID": orderDisplayId,
        "Distributor Name": r.partyName,

        // 🔹 Order Date = createdAt (DISPLAY ONLY)
        "Order Date": r.createdAt?.toDate
          ? r.createdAt.toDate().toLocaleDateString("en-IN")
          : "-",

        // 🔹 Approved At = FINAL SOURCE OF TRUTH
        "Approved At": r.approvedAt?.toDate
          ? r.approvedAt.toDate().toLocaleString("en-IN")
          : "-",

        "Total Qty": r.totalQty,
        "Total Amount": Number(r.totalAmount || 0).toFixed(2),
      };
    });


    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "OrderHeadReport");

    XLSX.writeFile(wb, "OrderHeadReport.xlsx");
  };

  // ------------------------
  // Search filter
  // ------------------------
  const filteredRows = rows.filter((r) => {
    const s = search.toLowerCase();

    return (
      r.id.toLowerCase().includes(s) ||
      (r.partyName || "").toLowerCase().includes(s) ||
      String(r.totalAmount || "").includes(s)
    );
  });

  return (
    <Layout>
      <div className="layout-content">
        {/* HEADER */}
        <div style={{ marginBottom: 40, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
            <div>
                <h1 style={{ fontSize: 32, marginBottom: 8, fontWeight: 900, letterSpacing: "-0.02em" }}>Order Intelligence Summary</h1>
                <p style={{ color: "var(--text-muted)", fontSize: 16 }}>Audit finalized transactions, logistics manifests, and fiscal documentation.</p>
            </div>
            <div style={{ display: "flex", gap: 12 }}>
                <button
                    onClick={exportXLSX}
                    className="btn-secondary"
                    style={{ background: "var(--surface)", display: "flex", alignItems: "center", gap: 8 }}
                >
                    <span style={{ color: "var(--success)" }}>Excel Audit</span>
                </button>
                <div style={{ display: "flex", alignItems: "center", gap: 12, background: "var(--surface)", padding: "0 16px", borderRadius: 12, border: "1px solid var(--border)", height: 48 }}>
                    <input 
                        type="date" 
                        value={fromDate} 
                        onChange={e => setFromDate(e.target.value)}
                        style={{ border: "none", background: "transparent", fontSize: 14, fontWeight: 700, color: "var(--text-main)", outline: "none" }}
                    />
                    <span style={{ color: "var(--text-muted)", fontWeight: 800 }}>→</span>
                    <input 
                        type="date" 
                        value={toDate} 
                        onChange={e => setToDate(e.target.value)}
                        style={{ border: "none", background: "transparent", fontSize: 14, fontWeight: 700, color: "var(--text-main)", outline: "none" }}
                    />
                </div>
            </div>
        </div>

        {/* SEARCH BAR */}
        <div className="premium-card" style={{ padding: 12, marginBottom: 32, background: "var(--surface-hover)", border: "1px solid var(--border)" }}>
            <input
                type="text"
                className="form-input"
                placeholder="Query by Distributor, Order ID, or Financial Total..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{ width: "100%", height: 56, fontSize: 16, background: "var(--surface)", border: "none" }}
            />
        </div>

        {/* DATA GRID */}
        <div className="premium-card" style={{ padding: 0, overflow: "hidden" }}>
            <div style={{ padding: "16px 24px", borderBottom: "1px solid var(--border)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 12, fontWeight: 800, color: "var(--text-muted)", textTransform: "uppercase" }}>Transaction Register</span>
                <span style={{ fontSize: 11, fontWeight: 600, color: "var(--primary)", background: "var(--surface-hover)", padding: "4px 12px", borderRadius: 20 }}>{filteredRows.length} MATCHES FOUND</span>
            </div>

            <div style={{ overflowX: "auto" }}>
                <table className="enterprise-table">
                    <thead>
                        <tr>
                            <th style={{ paddingLeft: 24 }}>ORDER IDENTIFIER</th>
                            <th>PARTNER ENTITY</th>
                            <th>TIMESTAMP (FINAL)</th>
                            <th style={{ textAlign: "right" }}>FISCAL TOTAL</th>
                            <th style={{ textAlign: "center" }}>LOGISTICS</th>
                            <th style={{ textAlign: "right", paddingRight: 24 }}>DOCUMENTATION & ACTIONS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredRows.length === 0 ? (
                            <tr>
                                <td colSpan="6" style={{ padding: 80, textAlign: "center", color: "var(--text-muted)" }}>
                                    No transaction records detected for the selected parameters.
                                </td>
                            </tr>
                        ) : (
                            filteredRows.map((r, i) => (
                                <tr key={r.id}>
                                    <td style={{ paddingLeft: 24 }}>
                                        <div style={{ fontWeight: 800, color: "var(--text-main)" }}>{r.displayOrderId}</div>
                                        <div style={{ fontSize: 10, color: "var(--text-muted)", marginTop: 2 }}>REF: {r.id.slice(0,8).toUpperCase()}</div>
                                    </td>
                                    <td>
                                        <div style={{ fontWeight: 700 }}>{r.partyName}</div>
                                        <div style={{ fontSize: 11, color: "var(--text-muted)" }}>{r.partyPhone}</div>
                                    </td>
                                    <td>
                                        <div style={{ fontSize: 13, fontWeight: 600 }}>{formatApprovedDate(r)}</div>
                                        <div style={{ fontSize: 10, color: "var(--text-muted)" }}>Approved: {r.approvedAt?.toDate?.()?.toLocaleTimeString()}</div>
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        <div style={{ fontSize: 16, fontWeight: 900, color: "var(--primary)" }}>₹{Number(r.totalAmount || 0).toLocaleString()}</div>
                                        <div style={{ fontSize: 10, color: "var(--text-muted)" }}>{r.totalQty} Packets</div>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <div style={{ display: "inline-block", padding: "4px 10px", borderRadius: 6, background: "var(--surface-hover)", fontSize: 11, fontWeight: 800 }}>
                                            {r.vehicleNo || "NO VEHICLE"}
                                        </div>
                                    </td>
                                    <td style={{ textAlign: "right", paddingRight: 24 }}>
                                        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", flexWrap: "wrap" }}>
                                            {r.challanPdfUrl && (
                                                <button onClick={() => window.open(r.challanPdfUrl, "_blank")} className="btn-small" style={{ background: "#8b5cf6", color: "white", fontSize: 10, fontWeight: 800, border: "none", padding: "6px 10px", borderRadius: 6 }}>DC</button>
                                            )}
                                            {r.tripSheetPdfUrl && (
                                                <button onClick={() => window.open(r.tripSheetPdfUrl, "_blank")} className="btn-small" style={{ background: "#10b981", color: "white", fontSize: 10, fontWeight: 800, border: "none", padding: "6px 10px", borderRadius: 6 }}>TS</button>
                                            )}
                                            {r.taxInvoicePdfUrl && (
                                                <button onClick={() => window.open(r.taxInvoicePdfUrl, "_blank")} className="btn-small" style={{ background: "#6366f1", color: "white", fontSize: 10, fontWeight: 800, border: "none", padding: "6px 10px", borderRadius: 6 }}>INV</button>
                                            )}
                                            <button onClick={() => generateEwayJson(r)} className="btn-small" style={{ background: "var(--primary)", color: "white", fontSize: 10, fontWeight: 800, border: "none", padding: "6px 10px", borderRadius: 6 }}>JSON</button>
                                            
                                            <button 
                                                onClick={() => sendWhatsApp(r.partyPhone, buildWaMessage(r))}
                                                disabled={!r.partyPhone}
                                                style={{
                                                  padding: "6px 10px",
                                                  background: r.partyPhone ? "#25D366" : "#ccc",
                                                  color: "#fff",
                                                  border: "none",
                                                  borderRadius: 6,
                                                  cursor: r.partyPhone ? "pointer" : "not-allowed",
                                                  fontSize: "10px",
                                                  fontWeight: 800
                                                }}
                                            >
                                                WA
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
      </div>
      <style>{`
          .btn-small { transition: all 0.2s; opacity: 0.9; cursor: pointer; }
          .btn-small:hover { opacity: 1; transform: translateY(-1px); box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1); }
      `}</style>
    </Layout>
  );
}

export default OrderHeadReport;
